var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 76,
    viewBox: "0 0 115 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_0_147)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.95129,
    y: 5,
    width: 104,
    height: 63,
    rx: 31.5,
    fill: "#F6C944"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7753 28.864H50.1113V31.456H40.7753V35.944H49.4153V38.392H40.7753V43.408H50.2793V46H37.7753V28.864ZM64.1965 46H61.6045V44.32H61.5565C61.1885 45.04 60.6525 45.56 59.9485 45.88C59.2445 46.184 58.5005 46.336 57.7165 46.336C56.7405 46.336 55.8845 46.168 55.1485 45.832C54.4285 45.48 53.8285 45.008 53.3485 44.416C52.8685 43.824 52.5085 43.128 52.2685 42.328C52.0285 41.512 51.9085 40.64 51.9085 39.712C51.9085 38.592 52.0605 37.624 52.3645 36.808C52.6685 35.992 53.0685 35.32 53.5645 34.792C54.0765 34.264 54.6525 33.88 55.2925 33.64C55.9485 33.384 56.6125 33.256 57.2845 33.256C57.6685 33.256 58.0605 33.296 58.4605 33.376C58.8605 33.44 59.2445 33.552 59.6125 33.712C59.9805 33.872 60.3165 34.08 60.6205 34.336C60.9405 34.576 61.2045 34.864 61.4125 35.2H61.4605V28.864H64.1965V46ZM54.6445 39.928C54.6445 40.456 54.7085 40.976 54.8365 41.488C54.9805 42 55.1885 42.456 55.4605 42.856C55.7485 43.256 56.1085 43.576 56.5405 43.816C56.9725 44.056 57.4845 44.176 58.0765 44.176C58.6845 44.176 59.2045 44.048 59.6365 43.792C60.0845 43.536 60.4445 43.2 60.7165 42.784C61.0045 42.368 61.2125 41.904 61.3405 41.392C61.4845 40.864 61.5565 40.328 61.5565 39.784C61.5565 38.408 61.2445 37.336 60.6205 36.568C60.0125 35.8 59.1805 35.416 58.1245 35.416C57.4845 35.416 56.9405 35.552 56.4925 35.824C56.0605 36.08 55.7005 36.424 55.4125 36.856C55.1405 37.272 54.9405 37.752 54.8125 38.296C54.7005 38.824 54.6445 39.368 54.6445 39.928ZM67.2524 28.864H69.9884V31.456H67.2524V28.864ZM67.2524 33.592H69.9884V46H67.2524V33.592ZM71.7214 33.592H73.7854V29.872H76.5214V33.592H78.9934V35.632H76.5214V42.256C76.5214 42.544 76.5294 42.792 76.5454 43C76.5774 43.208 76.6334 43.384 76.7134 43.528C76.8094 43.672 76.9454 43.784 77.1214 43.864C77.2974 43.928 77.5374 43.96 77.8414 43.96C78.0334 43.96 78.2254 43.96 78.4174 43.96C78.6094 43.944 78.8014 43.912 78.9934 43.864V45.976C78.6894 46.008 78.3934 46.04 78.1054 46.072C77.8174 46.104 77.5214 46.12 77.2174 46.12C76.4974 46.12 75.9134 46.056 75.4654 45.928C75.0334 45.784 74.6894 45.584 74.4334 45.328C74.1934 45.056 74.0254 44.72 73.9294 44.32C73.8494 43.92 73.8014 43.464 73.7854 42.952V35.632H71.7214V33.592Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_0_147",
    x: 0.951294,
    y: 0,
    width: 114,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_147"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_147",
    result: "effect2_dropShadow_0_147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_147",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f40776c85bfb4989863b1344890fdf3c.svg";
export { ForwardRef as ReactComponent };